module.exports = __webpack_public_path__ + "img/header_logo_sm.b52664f0.png";